import { useQuery } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Issue } from 'types';

type SearchIssuesParams = {
  jql: string;
  projectId?: string;
};

export const useSearchIssues = (params: SearchIssuesParams, enabled = true) =>
  useQuery<Issue[]>({
    queryKey: ['issues', 'search', params],
    queryFn: async () => {
      const response = await customAxios.get<Issue[]>('/issues/search', {
        params: {
          jql: params.jql,
          projectId: params.projectId,
        },
      });
      return response.data;
    },
    enabled: enabled && !!params.jql,
  });
